module.exports = __webpack_public_path__ + "img/a4f74d5.png";